import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsCategoryHeaderBlock {
    export const BLOCK_ID = 'cms-category-header';

    export interface IBlockDataContent {
        title?: string;
        description?: string;
        variant?: 'default' | 'light';
        links?: IQuickLink[];
        hideBreadcrumb?: boolean;
    }

    export interface IQuickLink {
        text: string;
        url: string;
        image?: string;
    }
}
@ICmsComponent<CmsCategoryHeaderBlockComponent>({
    id: NCmsCategoryHeaderBlock.BLOCK_ID,
    block: {
        url: NCmsCategoryHeaderBlock.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Category header',
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'variant',
            type: NICmsContentField.EFieldType.choice,
            title: 'Variant',
            options: [
                {
                    key: 'default',
                    title: 'Dark'
                },
                {
                    key: 'light',
                    title: 'Light'
                }
            ],
            default: 'default'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title'
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'description',
            title: 'Description'
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'hideBreadcrumb',
            title: 'Hide breadcrumb',
            default: false
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'links',
            title: 'Links',
            itemName: 'Link',
            itemNameField: 'title',
            defaultSize: 0,
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'text',
                    title: 'Text',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'url',
                    title: 'Url',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image'
                }
            ]
        }
    ]
})
@Component({
    selector: 'cms-category-header-block',
    templateUrl: './cms-category-header-block.html',
    styleUrls: ['cms-category-header-block.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsCategoryHeaderBlockComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NCmsCategoryHeaderBlock.IBlockDataContent;

    @Input()
    categoryName?: string;

    @Input()
    categoryDescription?: string;

    @Input()
    categoryImage?: string;

    @Input()
    variant?: string;

    @Input()
    hideBreadcrumb?: boolean;
}
